import { mvteApiInstance } from "../mvte.api";
import { GroupeRoleGUID } from "src/types/group-role-guid";


async function getGroupRolePermissions(data: {params: {roleGuids: Array<string>}})
{
    const response = await mvteApiInstance.get<GroupeRoleGUID>(
            `ad/role`,
            {
                params: {
                    roleGuids: data.params.roleGuids,
                }
            },
        );
    
        return response.data;
}

const mvteHomeApi =
{
    getGroupRolePermissions,
}

export {mvteHomeApi};